import { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { authApi } from "../services/auth";
import { useAuth } from "../contexts/AuthContext";
import { Loader2 } from "lucide-react";

/**
 * Emergent Google OAuth callback handler.
 * Detects `session_id` in URL hash, exchanges it via backend, sets cookie, redirects.
 * REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
 */
export default function AuthCallback() {
  const navigate = useNavigate();
  const { refresh } = useAuth();
  // Use useRef to guard against StrictMode double-invocation
  const hasProcessed = useRef(false);

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      navigate("/signin", { replace: true });
      return;
    }
    const sessionId = decodeURIComponent(match[1]);
    (async () => {
      try {
        await authApi.googleSession(sessionId);
        await refresh();
        // Clear hash and navigate
        window.history.replaceState(null, "", window.location.pathname);
        navigate("/", { replace: true });
      } catch (e) {
        console.error("Google auth failed:", e);
        navigate("/signin?error=google", { replace: true });
      }
    })();
  }, [navigate, refresh]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F9F9F8]">
      <div className="text-center">
        <Loader2 className="h-8 w-8 animate-spin text-[#061426] mx-auto mb-4" />
        <p className="text-[#5C5C59] font-mono text-sm uppercase tracking-wider">
          Authenticating with Google
        </p>
      </div>
    </div>
  );
}
